// extracted by mini-css-extract-plugin
export default {"root":"form-styled-input-base__root___U3_Ok","input":"form-styled-input-base__input___ymJGI"};